import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

import { getLabelByTipo } from './TipoBemUtils';

export class PatrimonioDetalheInformacao extends Component {
  static propTypes = {
    bem: PropTypes.object.isRequired
  };

  render() {
    const { bem } = this.props;
    const tipo = getLabelByTipo(bem.getIn(['id', 'tipo']));

    return (
      <Panel title={`Tombamento ${bem.getIn(['id', 'chapa'])} - ${tipo}`}>
        <DisplayData border>
          <DisplayDataRow>
            <DisplayDataItem
              sm={12}
              title="Descrição"
              value={bem.get('descricao')}
              id="descricao"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Tombamento"
              value={bem.getIn(['id', 'chapa'])}
              id="chapa"
            />
            <DisplayDataItem
              sm={4}
              title="Tipo Patrimônio"
              value={tipo}
              id="tipo"
            />
            <DisplayDataItem
              sm={4}
              title="Aquisição"
              value={DateUtils.formatDateTimeShort(bem.get('dataAquisicao'))}
              id="aquisicao"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Matrícula"
              value={bem.getIn(['imovel', 'matricula'])}
              id="matricula"
            />
            <DisplayDataItem
              sm={4}
              title="Data Matrícula"
              value={DateUtils.formatDateTimeShort(
                bem.getIn(['imovel', 'dataMatricula'])
              )}
              id="dataMatricula"
            />
            <DisplayDataItem
              sm={4}
              title="Local"
              value={bem.get('localAtual')}
              id="local"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Valor"
              value={NumberUtils.format(bem.get('valorAtual'), 'R$ 0,0.00')}
              id="valor"
            />
            <DisplayDataItem
              sm={4}
              title="Nota Fiscal"
              value={bem.get('notaFiscal')}
              id="notaFiscal"
            />
            <DisplayDataItem
              sm={4}
              title="Tipo de Incorporação"
              value={bem.getIn(['incorporacao', 'descricao'])}
              id="tipoIncorporacao"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Cidade"
              value={bem.getIn(['imovel', 'cidade', 'descricao'])}
              id="cidade"
              show={bem.get('imovel') != null}
            />
            <DisplayDataItem
              sm={4}
              title="Bairro"
              value={bem.getIn(['imovel', 'bairro', 'descricao'])}
              id="bairro"
              show={bem.get('imovel') != null}
            />
            <DisplayDataItem
              sm={4}
              title="Logradouro"
              value={bem.getIn(['imovel', 'logradouro', 'descricao'])}
              id="logradouro"
              show={bem.get('imovel') != null}
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="CEP"
              value={bem.getIn(['imovel', 'cep'])}
              id="cep"
              show={bem.get('imovel') != null}
            />
            <DisplayDataItem
              sm={4}
              title="Número"
              value={bem.getIn(['imovel', 'numero'])}
              id="numero"
              show={bem.get('imovel') != null}
            />
            <DisplayDataItem
              sm={4}
              title="Complemento"
              value={bem.getIn(['imovel', 'complemento'])}
              id="complemento"
              show={bem.get('imovel') != null}
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              id="situacao"
              title="Situação"
              value={bem.get('baixado') ? 'Baixado' : 'Ativo'}
            />
            <DisplayDataItem
              sm={4}
              id="dataBaixa"
              title="Data Baixa"
              value={DateUtils.formatDateTimeShort(bem.get('dataBaixa'))}
            />
            <DisplayDataItem
              sm={4}
              id="tipoBaixa"
              title="Tipo da Baixa"
              value={bem.get('tipoBaixa')}
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={12}
              id="justificativa"
              title="Justificativa"
              value={bem.get('justificativa')}
            />
          </DisplayDataRow>
          <DisplayDataRow>
            <DisplayDataItem
              sm={12}
              id="nomeComprador"
              title="Responsável Recebimento"
              value={bem.get('nomeComprador')}
            />
          </DisplayDataRow>
          {bem.get('comodato') && (
            <React.Fragment>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={3}
                  title="Número Comodato"
                  value={bem.getIn(['comodato', 'id', 'codigo'])}
                  id="codigoComodato"
                />
                <DisplayDataItem
                  sm={3}
                  title="Local Comodato"
                  value={bem.getIn(['comodato', 'local'])}
                  id="localComodato"
                />
                <DisplayDataItem
                  sm={3}
                  title="Data Inicio"
                  value={DateUtils.formatDateTimeShort(
                    bem.getIn(['comodato', 'dataInicio'])
                  )}
                  id="dataInicio"
                />
                <DisplayDataItem
                  sm={3}
                  title="Data Fim"
                  value={DateUtils.formatDateTimeShort(
                    bem.getIn(['comodato', 'dataFim'])
                  )}
                  id="dataFim"
                />
              </DisplayDataRow>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={12}
                  title="Descrição Comodato"
                  value={bem.getIn(['comodato', 'descricao'])}
                  id="descricaoComodato"
                />
              </DisplayDataRow>
            </React.Fragment>
          )}
        </DisplayData>
      </Panel>
    );
  }
}

export default PatrimonioDetalheInformacao;
